import { useEffect, useState } from "react"
import {
  Button,
  Textarea,
  Label,
  Input,
} from "@/components/ui"
import { Loader2 } from "lucide-react"

import { Example } from "./ExampleContent"
import { TooltipInfo } from "@/components/ui/TooltipInfo"
import { useEmailTypeSettings, useUpdateEmailTypeSettings } from "@/hooks/useEmailSettings"

export function FollowUpEmail() {
  const [subject, setSubject] = useState('');
  const [prompt, setPrompt] = useState('');
  const [originalValues, setOriginalValues] = useState({ subjects: '', prompt: '', enabled: false });
  const [enabled, setEnabled] = useState(false);
  const { data: email } = useEmailTypeSettings('follow_up');
  const { mutate: updateEmailSettings, isPending } = useUpdateEmailTypeSettings();


  const cancel = () => {
    setSubject(originalValues.subjects);
    setPrompt(originalValues.prompt);
    setEnabled(originalValues.enabled);
  }
  
  useEffect(() => {
    setSubject(email?.follow_up?.subject || '');
    setPrompt(email?.follow_up?.prompt || '');
    setOriginalValues({ subjects: email?.follow_up?.subject || '', prompt: email?.follow_up?.prompt || '', enabled: email?.follow_up?.enabled || false });
    if (email?.follow_up?.enabled !== undefined) setEnabled(email.follow_up.enabled);
  }, [email?.follow_up?.subject, email?.follow_up?.prompt]);

  const isChanged = (subject.trim() !== email?.follow_up?.subject?.trim() && subject.trim() !== '') || (prompt !== email?.follow_up?.prompt); 
  return (
    <div className="col-span-3 relative">
      <div className="flex items-start justify-between ">
        <div>
          <h1 className="flex items-center gap-2 text-lg font-bold text-gray-900 dark:text-gray-100 mb-2">
          Follow-up Email Settings
          </h1>
          <p className="text-sm text-gray-500 dark:text-gray-400 italic mb-10">Follow-up emails help you reconnect with clients after a call, share important details, and keep the conversation going.</p>
        </div>
      </div>
      
      <div className="flex flex-col gap-10 "> 
      <div>
        <div className="flex items-center mb-1 gap-2">
          <Label htmlFor="subject" className="font-semibold text-gray-900 text-base">Subject</Label>
          <TooltipInfo description="Subject is the short headline of an email that the recipient sees in their inbox. It should briefly reflect the main idea of the email and encourage them to open it." />
        </div>
        <Input id="subject" placeholder="Subject" className="mt-1 h-12 block w-full" type="text" value={subject} onChange={(e) => setSubject(e.target.value)} />
      </div>
      <div>
        <div className="flex items-center mb-1 gap-2">
          <Label htmlFor="body" className="font-semibold text-gray-900 text-base">Body</Label>
          <TooltipInfo description="Provide clear instructions and restrictions for the AI assistant on how to generate the email content." />
          
        </div>
        <Textarea
          id="system-prompt"
          value={prompt}
          rows={4}
          onChange={(e) => setPrompt(e.target.value)}
          className="mt-1 text-sm mb-4"
          placeholder="AI email generation instructions"
        />
      </div>
      </div>

      <Example prompt={prompt} type="follow_up" />
      {isChanged && 
        <div className="flex gap-2 mt-20 ">
          <Button 
            variant="default" 
            className="w-[100px]" 
            onClick={()=> updateEmailSettings({ type: 'follow_up', settings: { subject, prompt, enabled } })} 
            disabled={isPending}
          >
            {isPending 
              ? (<><Loader2 className="mr-2 h-4 w-4 animate-spin" />Save</>) 
              : ('Save')
            }
          </Button>
          <Button variant="outline" className="px-6" onClick={cancel}>
            Cancel
          </Button>
        </div>
      }
    </div>
  )
}